import React, { useEffect, useState } from 'react';
import Loader from '../common/Loader';
import useApiGet from '../../hooks/useApiGet';
import { Navigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { categorySet, countrySet, dateSet, filterReset } from '../../store/filterSlice';
/**
 * Компонент для предварительной установки значения фильтра.
 * Параметры строки запроса:
 * type - 'exhibitors' или 'activities' или 'exhibitor' или 'activity'
 * event - event id
 * id - exhibitor id или activity id
 * cats - категории
 * cntrs - страны
 * dates - даты
 * lang - язык интерфейса
 * Мы запрашиваем категории, страны и даты с сервера чтобы проверить что переданные идентификаторы
 * для фильтра присуствуют в списках. Некорректные идентификаторы мы в фильтр не заносим.
 */
const Preset = () => {
    const dispatch = useDispatch();
    const { id, type, event, cats, cntrs, dates, lang } = useParams();
	const [ dataCats, errorCats ] = useApiGet({ method: '/categories', params: { event } });
    const [ dataCntrs, errorCntrs ] = useApiGet({ method: `/countries/${event}` });
	const [ dataEvent, errorEvent ] = useApiGet({ method: `/events/${event}` });
    const [ catsReady, setCatsReady ] = useState(false);
    const [ cntrsReady, setCntrsReady ] = useState(false);
    const [ datesReady, setDatesReady ] = useState(false);

    // Сбросим фильр просто на всякий случай
    useEffect(() => {
        dispatch(filterReset());
    }, [ dispatch ]);

    // Получили данные о категориях
    useEffect(() => {
        // Если была ошибка запроса, то и устанавливать в фильтр нечего
        if(errorCats) {
            setCatsReady(true);
            return;
        }
        if(!dataCats) return; // Данных еще нет
        // Проходим по всем идентификаторам из запроса
        cats.split(',').forEach(id => {
            const found = dataCats.categories.find(c => c._id === id);
            if(found) dispatch(categorySet(id));
        });
        setCatsReady(true);
    },[ cats, dataCats, errorCats, dispatch ]);

    // Получили данные о странах
    useEffect(() => {
        // Если была ошибка запроса, то и устанавливать в фильтр нечего
        if(errorCntrs) {
            setCntrsReady(true);
            return;
        }
        if(!dataCntrs) return; // Данных еще нет
        // Проходим по всем идентификаторам из запроса
        cntrs.split(',').forEach(alpha3 => {
            const found = dataCntrs.countries.find(c => c.alpha3 === alpha3);
            if(found) dispatch(countrySet(alpha3));
        });
        setCntrsReady(true);
    },[ cntrs, dataCntrs, errorCntrs, dispatch ]);

    // Получили данные о мероприятии
    useEffect(() => {
        // Если была ошибка запроса, то и устанавливать в фильтр нечего
        if(errorEvent) {
            setDatesReady(true);
            return;
        }
        if(!dataEvent) return; // Данных еще нет
        // Проходим по всем идентификаторам из запроса.
        // Специально добавляем пробел в конце чтобы исключить частичное указание даты.
        dates.split(',').forEach(date => {
            const found = dataEvent.event.dates.find(d => d.startsWith(`${date} `));
            if(found) dispatch(dateSet(date));
        });
        setDatesReady(true);
    },[ dates, dataEvent, errorEvent, dispatch ]);

    if(!catsReady || !cntrsReady || !datesReady) return <Loader/>;

    if(type === 'activity' || type === 'exhibitor') return <Navigate to={`../${type}/${id}/lang/${lang}`}/>;

    return <Navigate to={`../${type}/${event}/lang/${lang}`}/>;
}

export default Preset;
